import { create } from "zustand";
import { persist,createJSONStorage  } from "zustand/middleware";

const useUserContextStore = create(
  persist(
    (set) => ({
  // ----- STATE -----
  context:null,

  // ----- ACTIONS -----
   setUserContext: (contextObj) => 
    set({
      context: contextObj
    }),
  
}),
{
      name: "userContext-storage",
      storage: createJSONStorage(() => localStorage),
    }
  ),
);

export default useUserContextStore;
